import React from "react";
import {Modal, OverlayTrigger, Tooltip} from "react-bootstrap";

/**
 * Hinweis-Dialog bei ungespeicherten Änderungen (AP5, Auftrag Punkt 3:
 * "beim Verlassen mit ungespeicherten Änderungen ein eigener
 * Hinweis-Dialog") - Ersatz für `confirm()`, das im Haus nicht zugelassen
 * ist (KONVENTIONEN.md Abschnitt 4).
 *
 * N7 (Sichtprüfung 2, 22.09.2026): jeder Knopf mit Erklär-Tooltip -
 * `<span>` um den Knopf, damit der Tooltip auch am (möglicherweise)
 * deaktivierten "Speichern und verlassen" erscheint (KONVENTIONEN.md
 * Abschnitt 4, Muster DataStatusBar.jsx).
 */
export default function UngespeichertHinweis({show, onSpeichernUndVerlassen, onVerwerfenUndVerlassen, onBleiben, speichern = false}) {
    return (
        <Modal show={show} onHide={onBleiben} centered backdrop="static" aria-labelledby="cosmos-ungespeichert-title">
            <Modal.Header closeButton>
                <Modal.Title id="cosmos-ungespeichert-title" style={{fontSize: 16}}>
                    Ungespeicherte Änderungen
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{fontSize: 14, lineHeight: 1.5}}>
                Diese Lieferung hat ungespeicherte Änderungen an Kopf oder Positionen. Beim Verlassen ohne Speichern
                gehen sie verloren.
            </Modal.Body>
            <Modal.Footer>
                <OverlayTrigger placement="top" overlay={<Tooltip id="ungespeichert-bleiben-tip">Schließt diesen Hinweis, ohne die Seite zu verlassen - die Änderungen bleiben ungespeichert im Formular stehen.</Tooltip>}>
                    <span>
                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onBleiben}>
                            Hierbleiben
                        </button>
                    </span>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip id="ungespeichert-verwerfen-tip">Verlässt die Seite und verwirft alle ungespeicherten Änderungen unwiderruflich.</Tooltip>}>
                    <span>
                        <button type="button" className="btn btn-outline-danger btn-sm" onClick={onVerwerfenUndVerlassen}>
                            Verwerfen und verlassen
                        </button>
                    </span>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip id="ungespeichert-speichern-tip">Speichert Kopf und Positionen und verlässt danach die Seite.</Tooltip>}>
                    <span>
                        <button type="button" className="btn btn-primary btn-sm" disabled={speichern} onClick={onSpeichernUndVerlassen}>
                            {speichern ? "speichert…" : "Speichern und verlassen"}
                        </button>
                    </span>
                </OverlayTrigger>
            </Modal.Footer>
        </Modal>
    );
}
